module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/align-justify-97993791c161f2c371c4d4f89e8d9652.svg";